import { render, staticRenderFns } from "./talent.vue?vue&type=template&id=5fa71929&scoped=true&"
import script from "./talent.vue?vue&type=script&lang=js&"
export * from "./talent.vue?vue&type=script&lang=js&"
import style0 from "./talent.vue?vue&type=style&index=0&id=5fa71929&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa71929",
  null
  
)

export default component.exports